import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "../Button/Button";
import BranchesSection from "./BrancheSection";
function transformArrayToObj(arr) {
  const result = {};

  arr?.forEach((item) => {
    result[item._id] = item.VehicleCategory.map((cat) => ({ _id: cat._id }));
  });

  return result;
}
export const CompanyListRow = ({ data, query, selectedBranches, getSelectedBranches, fielddata, TypeOfPortal }) => {
  const [showBrach, setShowBranch] = useState(false);
  // const FormData = useSelector((store) => store.FormFieldData);
  // console.log(data);
  const handleSelectCompany = () => {
    setShowBranch(true);
  };
  // 652e9810462aa53014769bd1
  const isCompanySelected = (companyId) => {
    return selectedBranches && selectedBranches[companyId] && selectedBranches[companyId].length > 0;
  };
  return (
    <>
      <div className="CompanyItem">
        {Object.keys(data).map((key) => {
          if (key !== "__typename" && key !== "_id") return <span>{data[key]}</span>;
        })}
        <Button
          action={handleSelectCompany}
          name={"CompanySelectButton"}
          text={isCompanySelected(data["_id"] || data["id"]) ? "Selected" : "Select"}
        />
      </div>
      {showBrach && (
        <BranchesSection
          getSelectedBranches={(data) => getSelectedBranches(data)}
          getDataQueryByID={query}
          Id={data["_id"] || data["id"]}
          selectedRows={selectedBranches}
          fielddata={fielddata}
          TypeOfPortal={TypeOfPortal}
          show={showBrach}
          closeBranchesSection={() => setShowBranch(false)}
        />
      )}
    </>
  );
};
